import { TypeOfVisit, visitTypes } from '../constants/filterOptions';

export default (type: string): string => {
  const typeNumber = Object.keys(visitTypes)
    .filter(x => Number.isNaN(Number(x)))
    .indexOf(type);
  return TypeOfVisit[typeNumber];
};
